import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { callGetPhotoByKeyAsync } from "../../../../apis/photos";
import { photosStore } from "../../../../stores/posts/usePhotosStore";
import { Box } from "@mui/material";
import { sleep } from "common-frontend-components";
import { 
// backgroundColor,
// primaryColor,
secondaryColor, textColor } from "../../../../assets/styles/colors";
import { ImageSlider } from "../../../popups/ImageFullView";
export function createImageProcessingAwaiter(getImage) {
    return async () => {
        console.log('waiting for image processing...');
        try {
            for (let i = 0; i < 100; i++) {
                try {
                    const photo = await getImage();
                    if (photo !== null) {
                        console.log('image processed!', photo);
                        return photo;
                    }
                    await sleep(1000);
                }
                catch (error) {
                    console.error('Error GetPhotoByPostId', error);
                }
            }
        }
        catch (error) {
            console.error('Error uploading', error);
            throw error;
        }
        return null;
    };
}
export const updatePhotosStoreAfterImageProcessing = async (res) => {
    return createImageProcessingAwaiter(() => callGetPhotoByKeyAsync(res.key))();
};
const activeStyle = {
    borderColor: '#2196f3'
};
const acceptStyle = {
    borderColor: '#00e676'
};
const rejectStyle = {
    borderColor: '#ff1744'
};
const thumbsContainer = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
};
const thumb = {
    display: 'inline-flex',
    borderRadius: 2,
    // border: `1px solid ${primaryColor}`,
    marginBottom: 8,
    marginRight: 8,
    padding: 0,
    boxSizing: 'border-box',
    cursor: 'pointer',
};
const thumbInner = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden'
};
const img = {
    display: 'block',
    maxWidth: '100%',
    width: 'auto',
    height: '100%'
};
const dropzoneBaseOptions = {
    accept: 'image/*',
    maxSize: 10 * 1024 * 1024,
};
function formatBytes(bytes, decimals = 2) {
    if (bytes === 0)
        return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
const maxSize = formatBytes(dropzoneBaseOptions.maxSize || 0);
export const ImagePreview = ({ photos, index, icons, onClick, style = {}, }) => {
    const previewPhoto = useMemo(() => {
        if (icons && icons.length > 0)
            return icons[0];
        // @ts-ignore
        return photos.find(i => i.phototype === 'preview');
    }, [photos, icons]);
    return (
    // @ts-ignore
    _jsx("div", { style: thumb, onClick: onClick ? onClick : () => photosStore.openImageFullViewUrl({ photos, index }), children: _jsx("div", { style: thumbInner, children: _jsx("img", { src: previewPhoto ? previewPhoto.url : photos[index]?.url, style: { ...img, ...style } }, void 0) }, void 0) }, void 0));
};
export const PhotoUploader = ({ onDrop, usePreviewFiles, setPreviewFiles, dropzoneOptions = {}, }) => {
    const { 
    // acceptedFiles,
    fileRejections, getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({ onDrop, ...dropzoneBaseOptions, ...dropzoneOptions });
    const acceptedFiles = usePreviewFiles();
    const [imgSlider, setImgSlider] = useState(undefined);
    useEffect(() => {
        let updatePreview = false;
        const update = {
            photos: [],
            index: 0,
        };
        acceptedFiles.forEach(i => {
            // @ts-ignore
            if (i.url === undefined) {
                // @ts-ignore
                i.url = URL.createObjectURL(i);
                updatePreview = true;
            }
            // @ts-ignore
            update.photos.push({ url: i.url });
        });
        setImgSlider(update);
        if (updatePreview)
            setPreviewFiles([...acceptedFiles]);
    }, [acceptedFiles]);
    return (_jsxs(_Fragment, { children: [_jsx("aside", { style: thumbsContainer, children: _jsx(ImageSlider, { imgSlider: imgSlider, setImgSlider: setImgSlider, 
                    // @ts-ignore
                    onImgClick: () => { photosStore.setImageFullViewUrl({ photos: acceptedFiles, index: 0 }); }, onClose: false }, void 0) }, void 0), _jsxs(Box, { sx: {
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    padding: '20px',
                    borderWidth: 2,
                    borderRadius: 2,
                    borderColor: textColor + '55',
                    borderStyle: 'dashed',
                    backgroundColor: secondaryColor,
                    color: textColor + 'aa',
                    outline: 'none',
                    transition: 'border .24s ease-in-out',
                    cursor: 'pointer',
                    '&:hover': {
                        borderColor: activeStyle.borderColor + '!important',
                    },
                    ...{
                        ...(isDragActive ? activeStyle : {}),
                        ...(isDragAccept ? acceptStyle : {}),
                        ...(isDragReject ? rejectStyle : {})
                    }
                }, ...getRootProps(), children: [_jsx("input", { ...getInputProps() }, void 0), isDragActive
                        ? _jsx("p", { children: "Drop the files here ..." }, void 0)
                        : _jsx("p", { children: "Drag and drop some files here, or click to select files" }, void 0), _jsxs("em", { children: ["(supported file types are ", dropzoneOptions.accept, ", file cannot exceed ", maxSize, ")"] }, void 0), fileRejections.length > 0 && _jsx("ul", { children: fileRejections.map(({ file, errors }, i) => (_jsxs("li", { style: { color: rejectStyle.borderColor }, children: [file.name, ".", file.type, " - ", formatBytes(file.size), _jsx("ul", { children: errors.map(e => (_jsx("li", { children: e.message }, e.code))) }, void 0)] }, i))) }, void 0)] }, void 0)] }, void 0));
};
//# sourceMappingURL=PhotoUploader.js.map